.c-grid-picker {
  --option-size: 1.75rem;

  display: flex;
  justify-content: flex-start;
  position: relative;

}

  .c-grid-picker__value {
    width: 2.625em;
    height: 2.625em;
    border: 1px solid #d4d4d8;
    border-radius: 0.25rem;
    padding: 0.25em;
    background: white;
  }

  .c-grid-picker__options {
    padding: 0 0.5em;
    display: grid;
    grid: auto-flow / repeat(6, var(--option-size));
    grid-column-gap: 3px;
    grid-row-gap: 3px;
  }

  .c-grid-picker__option {
    border: 1px solid white;
    border-radius: 0.25rem;
    width: var(--option-size);
    height: var(--option-size);
    color: #27272a;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 3px;
  }

  .c-grid-picker__option:hover {
      border-color: #d4d4d8;
      color: #27272a;
    }

  .c-grid-picker__option:visited,
    .c-grid-picker__option:active,
    .c-grid-picker__option:focus {
      color: #27272a;
    }

  .c-grid-picker__option--blank {
      background: linear-gradient(-45deg, #fff 48%, #d4d4d8 48%, #d4d4d8 52%, #fff 53%);
      border-color: #a1a1aa;
    }

  .c-grid-picker__value > *, .c-grid-picker__option > * {
      width: 100%;
      height: 100%;
      display: flex !important;
      justify-content: center;
      align-items: center;
    }

  .c-grid-picker .c-dropdown {
    display: flex;
    position: initial;
  }

/*# sourceMappingURL=data:application/json;base64,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 */